<template>
    <div class="create-user">

        <div class="title is-3">Acessar minha conta</div>

        <form @submit.prevent="login">
            <b-field label="E-mail">
                <b-input
                    v-model="loginData.email"
                    type="email"
                    placeholder="Informe o seu e-mail"
                    required
                />
            </b-field>
            <b-field label="Senha">
                <b-input
                    v-model="loginData.password"
                    type="password"
                    placeholder="Informe uma senha"
                    minlength="6"
                    required
                />

            </b-field>
            <button type="submit" class="button is-primary is-rounded is-fullwidth is-large">
                Acessar
            </button>

            <div class="margin-top has-text-centered">
                <a role="button" @click="openForgotPasswordModal">Esqueceu sua senha?</a>
            </div>

        </form>
    </div>
</template>

<script>
import auth from '@/services/auth';
import ForgotPasswordModal from "@/modules/users/components/ForgotPasswordModal";

export default {
    name: "AuthUserLogin",

    data() {
        return {
            loginData: {
                email: null,
                password: null
            }
        };
    },

    methods: {
        async login() {
            const loading = this.$buefy.loading.open();
            const {email, password} = this.loginData;

            try {
                const result = await auth.signInWithEmailAndPassword(email, password);
                this.$store.dispatch('changeUser', result.user);
            } catch (e) {
                const errors = {
                    400: 'Senha inválida',
                    'unknown': 'Ocorreu um erro desconhecido, por favor tente novamente mais tarde',
                    'auth/user-not-found': 'Usuário não encontrado',
                    'auth/user-disabled': 'Usuário está desabilitado, por favor entre em contato com o suporte do sistema'
                }

                const errorCode = e.code || 'unknown';
                const message = errors[errorCode] || errors['unknown'];

                this.$buefy.toast.open({
                    type: "is-danger",
                    message
                });
            }

            loading.close();
        },

        openForgotPasswordModal() {
            this.$buefy.modal.open({
                component: ForgotPasswordModal
            });
        }

    }
};
</script>
